import moment from 'moment';
import type { DateRange } from '../../../commonComponents/DateRangePicker/types';

/** Every range-scoped endpoint defaults to a trailing 30 days server-side. */
export const DEFAULT_RANGE_DAYS = 30;

/** The API takes plain `YYYY-MM-DD` strings. */
export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const DISPLAY_DATE_FORMAT = 'MMM DD, YYYY';

/** The trailing-30-day range every range-scoped screen opens on. */
export const createDefaultRange = (): DateRange => ({
  startDate: moment().subtract(DEFAULT_RANGE_DAYS, 'days'),
  endDate: moment(),
});

export interface ApiDateRange {
  startDate?: string;
  endDate?: string;
}

/**
 * A picker range as the `startDate`/`endDate` query params the API expects.
 * An unset bound is omitted rather than sent empty, so the server applies its own
 * trailing-30-day default.
 */
export const toApiDateRange = (range: DateRange): ApiDateRange => ({
  startDate: range.startDate
    ? moment(range.startDate).format(API_DATE_FORMAT)
    : undefined,
  endDate: range.endDate ? moment(range.endDate).format(API_DATE_FORMAT) : undefined,
});
